import { Link } from "react-router-dom";
import { MoonStar } from "lucide-react";

// Écran affiché quand le mois de rencontres est terminé : le tirage reste consultable,
// mais Découvrir / Matchs / Chat demandent un nouveau déblocage.
export const AccessExpired = () => (
  <div className="relative flex min-h-[calc(100vh-64px)] items-center justify-center overflow-hidden px-4 py-16" data-testid="access-expired">
    <img src="/assets/mandala-sun.jpeg" alt="" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.12]" />
    <div className="relative w-full max-w-md rounded-3xl border border-gold/50 bg-white/90 p-10 text-center shadow-card backdrop-blur-md">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#D97B8F]/15">
        <MoonStar size={30} className="text-[#D97B8F]" />
      </div>
      <h1 className="mt-5 font-serif text-2xl font-medium text-ink">Votre mois de rencontres est terminé</h1>
      <p className="mt-3 text-sm leading-relaxed text-clay">
        Pour recevoir de nouveaux matchs, prolongez votre accès d'un mois puis découvrez vos nouveaux matchs ! Vous pouvez refaire le test si vous le souhaitez, mais <strong>aucune obligation</strong> — vos réponses sont enregistrées.
      </p>
      <Link
        to="/quiz"
        data-testid="access-expired-retake-link"
        className="mt-7 inline-block rounded-full bg-terra px-7 py-3.5 text-sm font-semibold text-cream shadow-boho transition-all duration-300 hover:scale-[1.03] hover:bg-terra-dark"
      >
        Prolonger mon accès — 10 €
      </Link>
      <p className="mt-3 text-[11px] text-stone2">Votre tirage et vos réponses restent gardés pour toujours.</p>
    </div>
  </div>
);
